import React from 'react';
import { ArrowTrendingUpIcon, ArrowTrendingDownIcon } from '@heroicons/react/24/outline';

interface StatCardProps {
    title: string;
    value: string | number;
    change?: {
        value: string;
        isPositive: boolean;
    };
    icon: React.ComponentType<any>;
    iconColor?: string;
    iconBgColor?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
    title,
    value,
    change,
    icon: Icon,
    iconColor = 'text-white',
    iconBgColor = 'bg-blue-500'
}) => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
                <div className="flex-1">
                    <p className="text-sm font-medium text-gray-600">{title}</p>
                    <p className="mt-2 text-3xl font-bold text-gray-900">{value}</p>
                    {change && (
                        <div className="mt-2 flex items-center">
                            {change.isPositive ? (
                                <ArrowTrendingUpIcon className="h-4 w-4 text-green-500 mr-1" />
                            ) : (
                                <ArrowTrendingDownIcon className="h-4 w-4 text-red-500 mr-1" />
                            )}
                            <span className={`text-sm font-medium ${change.isPositive ? 'text-green-600' : 'text-red-600'
                                }`}>
                                {change.value}
                            </span>
                        </div>
                    )}
                </div>
                <div className={`${iconBgColor} ${iconColor} p-3 rounded-lg`}>
                    <Icon className="h-6 w-6" />
                </div>
            </div>
        </div>
    );
};
